import React, { useCallback } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectVehiclePopupDetails, setPopupVisibility } from '../../../store/serviceCalendarSlice';
import dayjs from 'dayjs';

export const ServiceCalendarPopupShowVehicle = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const vehiclePopupDetails = useSelector(selectVehiclePopupDetails);
    const { id, vehicleMake, carName, vehicleReg, serviceDue } = vehiclePopupDetails.vehicle;

    const { left, top } = vehiclePopupDetails.position;

    const handleYearView = () => {
        // Dispatch consolidated action to show Year View Popup
        dispatch(
            setPopupVisibility({
                popupName: 'yearView',
                isVisible: true,
                vehicleDetail: vehicleReg,
                vehicleId: id
            })
        );
    };

    const handleAdd = (path) => {
        navigate(`/${path}/add?vehicle_id=${id}&from=calendar`);
    };

    const handleClose = useCallback(() => {
        dispatch(setPopupVisibility({ popupName: 'vehicle', isVisible: false }));
    }, [dispatch]);

    return (
        <div
            style={{
                width: '273px',
                left: `${left}px`,
                top: `${top}px`,
                position: 'absolute',
                background: 'white',
                border: '1px solid lightgrey',
                boxShadow: '5px 4px 4px rgba(10, 10, 10, 0.4)',
                zIndex: '999'
            }}
            className="text-[13px] font-normal text-[#333333] font-['Roboto']">
            <div className="p-1 bg-[#3b8eb9] text-white flex justify-between items-center">
                <div className="font-bold text-sm">{vehicleReg}</div>
                <CloseOutlined onClick={handleClose} className="hover:bg-gray-500" />
            </div>
            <div style={{ width: '100%', padding: '10px' }}>
                <div className="w-full flex gap-2 mt-3">
                    <div className="w-[22%]">Vehicle</div>

                    <div className="w-[78%] flex flex-col gap-2">
                        <div className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden" style={{ border: '1px solid grey' }}>
                            {vehicleReg}
                        </div>
                        <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden">
                            {carName}
                        </div>
                        <div style={{ border: '1px solid grey' }} className="w-full h-[21.6px] bg-[#F9F9F9] rounded-sm p-[2px] overflow-hidden">
                            {vehicleMake}
                        </div>
                    </div>
                </div>

                <div style={{ border: '1.5px solid grey', padding: '2px' }} className="h-[21.6px] bg-[#F9F9F9] rounded-sm mt-4 mb-2">
                    {serviceDue}
                </div>
                <button className="btn-action-in-popup my-2 service-status" onClick={handleYearView}>
                    See Yearly Schedule
                </button>
                <button className="btn-action-in-popup" onClick={() => handleAdd('scheduled-services')}>
                    Add Scheduled Service
                </button>
                <button className="btn-action-in-popup" onClick={() => handleAdd('unscheduled-services')}>
                    Add unscheduled Service
                </button>
                <button className="btn-action-in-popup" onClick={() => handleAdd('defect-tickets')}>
                    Add Defect
                </button>
            </div>
        </div>
    );
};
